/* eslint-disable no-dupe-keys */
const apiEndpoints = {
  prod: {
    baseUrl: 'https://api.ace.online/',
    sitemapBaseUrl: 'https://deep-learn.in/',
    cloudFrontUrl: 'https://duucnkfm18wax.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */
    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]

    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    cancelJobs:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    getTranscodingTemplate:
      'https://rdne34atwf.execute-api.ap-south-1.amazonaws.com/production/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',

    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
  },
  preProd: {
    baseUrl: 'https://pre-prod-api.ace.online/',
    sitemapBaseUrl: 'https://deep-learn.in/',
    cloudFrontUrl: 'https://duucnkfm18wax.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */
    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]

    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    cancelJobs:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',
    getTranscodingTemplate:
      'https://rdne34atwf.execute-api.ap-south-1.amazonaws.com/production/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://hea3usdkkc.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',

    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
  },
  staging: {
    baseUrl: 'https://api-staging.ace.online',
    sitemapBaseUrl: 'https://staging.deep-learn.in/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    /* ************************************ [PUBLISHER] ************************************* */

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default', // Check
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
  },

  test: {
    baseUrl: 'https://api-test.ace.online',
    sitemapBaseUrl: 'http://dev.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',

    /* ************************************ [PUBLISHER] ************************************* */

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
  },

  dev: {
    baseUrl: 'https://api-dev.ace.online',
    sitemapBaseUrl: 'http://test.ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    //Student updates start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    //Student updates end

    /* ************************************ [PUBLISHER] ************************************* */

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',

    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',

    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
  },

  local: {
    baseUrl: 'https://api-test.ace.online',

    sitemapBaseUrl: 'http://useDebugValue(value).ace.online/',
    cloudFrontUrl: 'https://d2aetrhkp37yll.cloudfront.net',
    studentResourceCloudfrontUrl: 'https://media-sr-test.ace.online',
    generateOTP: '/auth/internal/send/otp',
    loginURL: '/auth/login',

    //Live Updates Start
    getAllLiveClassData: '/batch/live-schedule/{instructorId}',
    getAllLiveBatches: '/batch/getBatchByStatus/ACTIVE',
    getBatchInfoByStatus: '/batch/getBatchInfoByStatus/ACTIVE',
    createLiveClass: '/batch/live-schedule/create',
    getAllBatchSubjects: '/batch/subject/all',
    getAllBatchTeachers: '/batch/teacher/all',
    getAllBatchChapters: '/batch/chapter/all',
    createBatchSubject: '/batch/subject/create',
    createBatchChapter: '/batch/chapter/create',
    showToStudents: '/batch/live-schedule/{liveClassId}/{enabled}',
    updateLiveClass: '/batch/live-schedule/update',
    deleteLiveClass: '/batch/live-schedule/delete/{liveClassId}',
    attachLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    deleteLiveClassRecording: '/batch/live-classes/{liveClassId}/live-class-recording',
    getAllZoomAccounts: '/batch/live-class/zoom-accounts',
    startLiveClass: '/batch/live-class/start/{liveClassId}',
    getClassRoomAttendanceDetails: '/batch/{classRoomType}/attendance/{liveClassId}',
    getStudentsAttendanceDetails: '/batch/{classRoomType}/attendance/students/{liveClassId}',

    //Live Updates End

    // Student Updates Start
    getAllStudentUpdates: '/notifications/notifications/getupdates',
    getStudentUpdateByUpdateType: '/notifications/notifications/getupdates/{updateType}',
    createStudentUpdate: '/notifications/notifications/createupdate',
    updateStudentUpdate: '/notifications/notifications/changeupdate',
    deleteStudentUpdate: '/notifications/notifications/deleteupdate?updateId={id}',
    // Student Updates Finish

    getAllUsers: '/users/user/internal/all?page=0&size=1000',
    getAllCourses: '/publisher/storemanager/course/all',
    getAllRoles: '/users/role/all',
    getAllSubjectsAdmin: '/subjects/subject/all', // [GET]
    getAllSubjectsbyCategory: '/subjects/subjects', // [Deprecated]           // [GET]
    getSubjectsInprogress: '/subjects/subjects/inprogress', // [GET]
    getSubjectsFinished: '/subjects/subjects/finished', // [GET]
    getSubjectsByStatus: '/subjects/subject/status/{status}', // [GET]
    getUnitsBySubjectId: '/subjects/subject/subjectid/{subjectid}', // [GET]
    getAssigneeBySubjectId: '/subjects/assignee/subjectid/{subjectid}', // [GET]
    getSubjectsByUserId: '/subjects/subjects/{userid}', // [GET]
    getUsersByRole: '/users/user/role/{role}', // [GET]
    sendForReview: '/subjects/subject/send/review/{userId}', // [GET]
    getSubjectVideos: '/file-explorer-service/cloud/subject/{subjectid}', // [GET]
    getSubjectAssignee: '/subjects/assignee/subjectid/{subjectId}', // [GET]

    getAllCoupons: '/publisher/coupon/user',
    getMobileValidation: '/users/user/validate/{mobileNumber}',

    getAllCatalogues: '/publisher/storemanager/coupon/all',
    getAllRoles: '/users/role/all',

    attachVideoToSubTopic: '/subjects/subject/attachvideo', // [PUT]
    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateCoupon: '/publisher/coupon',
    updateSubjectInfo: '/subjects/subject', // [PUT]
    revertOrDeclineASubject: '/subjects/revert/subjectid/{subjectId}', // no payload                      // [PUT]
    approveASubject: '/subjects/subject/send/approve/{userId}', // need to verify         // [PUT]
    deleteUnitTopicOrSubTopic: '/subjects/subject', // [PUT]
    deleteASubject: '/subjects/subject/subjectid/{subjectid}', // no payload    [DELETE]

    updateSubjectInfoAssignee: '/subjects/subject/assignee', // [PUT]
    updateSubjectInfo: '/subjects/subject', // [PUT]
    updateUser: '/users/user',

    createUser: '/users/user',
    createSubject: '/subjects/subject/assignee', // [POST]
    createCoupon: '/publisher/coupon',
    getVideoUrl: '/cms/pagecontent/videourl', // [POST]

    /* ************************************ [PUBLISHER] ************************************* */

    // [CATALOGUEMANAGER] :

    // [GET]
    getCatalogueList: '/publisher/cataloguemanager/all',
    getIndividualCatalogue: '/publisher/cataloguemanager/catalogue/{catalogueid}',
    getCatalogueSubjectList: '/publisher/publisher/subject/all',

    // [POST]
    createCatalogue: '/publisher/cataloguemanager/create',

    // [PUT]
    updateCatalogue: '/publisher/cataloguemanager/update',
    updateCatalogueStatus: '/publisher/cataloguemanager/catalogue/{catalogueId}',

    // [STOREMANAGER] :
    getAllRecommendedCourses: '/publisher/storemanager/recommendation/storelisting/{id}',
    // [GET]

    getStoreList: '/publisher/storemanager/all',
    getStoreById: '/publisher/storemanager/store/{storeId}',

    // [POST]

    createStore: '/publisher/storemanager/create',

    // [PUT]

    updateStore: '/publisher/storemanager/update',
    updateCategoryOrder: '/publisher/category/order/update',

    // [DELETE]

    deleteAStoreListing: '/publisher/storemanager/store/{storeId}',

    // [OTSMANAGER] :

    // [GET]

    getOtsCatalogueList: '/publisher/otsmanager/catalogue/all',
    getOtsSubscriptionsByID: '/publisher/otsmanager/subscription/catalogueid/{catalogueId}',

    // [POST]

    // [PUT]

    // [DELETE]

    //

    // [GET]
    getCurrentCatalogueSubjectList: '/publisher/catalogue/catalogueid/{catalogueid}/subjects',

    getCategoryList: '/publisher/category/all',

    // [POST]
    addCategory: '/publisher/category',

    // [DELETE]
    deleteCatalogue: '/publisher/catalogue/catalogueid/{catalogueId}',
    deleteCategory: '/publisher/category/{categoryId}',

    // [PUT]
    addOrUpdateCategory: '/publisher/category',
    updateSubscriptionOts: '/publisher/otsmanager/update',

    /* *************************************** [TRANSCODING MANAGER] ************************************ */

    // [GET]
    getTobeTranscodedJobs: '/file-explorer-service/cloud/videos/to-be-transcoded/{videoType}',

    // [POST]
    getMediaConvertJobsByStatus:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    cancelJobs:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',
    getTranscodingTemplate:
      'https://w1dxgfnb25.execute-api.ap-south-1.amazonaws.com/development/list-media-convert-template',
    queueArn: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Default',
    queueArnReserved: 'arn:aws:mediaconvert:ap-south-1:445805680910:queues/Reserved',
    createMediaConvertJob:
      'https://gw5hqe19kh.execute-api.ap-south-1.amazonaws.com/default/deep-learn-vod-transcoding-test',

    /* *************************************** [LEGAL PAGE] ************************************  */
    allTnc: '/users/tnc/all',
    updateTnc: '/users/tnc/latest',

    /* *************************************** [File Explorer] ************************************  */
    getAllSubjects: '/file-explorer-service/cloud/getsubjects',
    getSubjectById: '/file-explorer-service/cloud/subject/{id}',
    getVideosFromTopics: '/file-explorer-service/cloud/getvideos',
    getPreviewVideosCatalogue: '/file-explorer-service/cloud/preview-videos/all',
    getPreviewVideosList: '/file-explorer-service/cloud/preview-videos/{id}',
    /* [COUPONS] */
    getSingleCouponDetails: '/publisher/coupon/couponid/{id}',
    expireCoupon: '/publisher/coupon/expire/{id}',

    /* [LIVE CLASS RECORDINGS] */
    getAllLiveClassRecordings:
      '/file-explorer-service/cloud/live-class-recording?page=0&size=10000&sort=ASC',
    /* [DELIVERY MANAGEMENT] */

    // [GET]
    getDeliveryPackageList: '/delivery/delivery/all/{status}',
    getDeliveryPackageById: '/delivery/delivery/id/{packageId}',
    // [PUT]
    updateDeliveryAddress: '/delivery/delivery/address',
    processDeliveryPackage: '/delivery/delivery/process',
    updateDeliveryPackage: '/delivery/delivery/update',
    // [GET]
    getStudentInfo: '/students/student/info',
    getSubscriptionsList: '/students/subscription/studentid',
    getInvoicesList: '/payments/student/subscription/studentid',
    verifyStudentEmail: '/users/user/autoverify/email_otp',
    getInvoice: '/payments/invoice/orderid/{orderId}',
    // [Batch management]
    getBatchList: '/batch/getAllBatch/pagination?page=0&size=1000',
    createBatch: '/batch/createBatch',
    updateBatch: '/batch/updateBatch',
    closeBatch: '/batch/closeBatch/{batchId}',
    getBranchList: '/batch/getAllBranch',
    createBranch: '/batch/createBranch',
    getProgramList: '/batch/getAllProgram',
    createProgram: '/batch/createProgram',
    getScheduler: '/users/user/role/{roleName}',
    getBatchDetails: '/batch/getBatchById/{batchId}',
    uploadStudents: '/batch/bulkUpload',
    updateBatchOfStudents: '/batch/updateStudentsBatch',
    getStudentsListByBatch: '/batch/batch/{batchId}/studentIds',
    getStudentsListByStudentIds: '/students/student/byStudentIds',
    // [Group management]
    getGroupList: '/batch/groups',
    createGroup: '/batch/group',
    deleteGroup: '/batch/groups/{groupId}',
  },
};

export { apiEndpoints };
